"use client";

import type { ChannelFeedEngagement } from "@mlx/contracts";
import { MessageSquareIcon } from "lucide-react";

import { Button } from "@/components/ui/button";

const REACTION_EMOJI = {
  thumbs_up: "👍",
  heart: "❤️",
  laugh: "😂",
  celebrate: "🎉",
  eyes: "👀",
  check: "✅",
} as const;

export function ChannelFeedEngagementSummary({
  engagement,
  onOpen,
}: {
  engagement: ChannelFeedEngagement;
  onOpen: () => void;
}) {
  return (
    <div className="mt-1.5 flex flex-wrap items-center gap-1">
      {engagement.reactions.map((reaction) => (
        <button
          key={reaction.reaction}
          type="button"
          aria-label={`Open thread with ${reaction.count} ${reaction.reaction} reactions`}
          className="inline-flex h-6 items-center gap-1 rounded-full border border-border/70 bg-background px-1.5 text-[11px] text-muted-foreground transition-colors hover:bg-muted hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/50"
          onClick={onOpen}
        >
          <span aria-hidden>{REACTION_EMOJI[reaction.reaction]}</span>
          {reaction.count}
        </button>
      ))}
      <Button
        type="button"
        variant="ghost"
        size="xs"
        className={engagement.unreadCount > 0
          ? "-ml-1 font-medium text-primary"
          : "-ml-1 text-muted-foreground"}
        onClick={onOpen}
      >
        <MessageSquareIcon aria-hidden />
        {engagement.unreadCount > 0 ? (
          <span className="rounded-full bg-primary px-1.5 text-[10px] leading-4 text-primary-foreground">
            {engagement.unreadCount} new
          </span>
        ) : null}
        {engagement.commentCount > 0
          ? `${engagement.commentCount} ${engagement.commentCount === 1 ? "reply" : "replies"}`
          : "Reply"}
      </Button>
    </div>
  );
}

export { REACTION_EMOJI };
